const EventTypeEnum = {
  ADVICE: 'advice',
  ALERT: 'alert',
  INFORMATION: 'information',
  WARNING: 'warning',
};

export default EventTypeEnum;
